import { FC, useMemo } from "react";
import StarRate from "../../../components/StarRate";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";
import { resolveWidgetV2Style } from "./widgetV2Styles";

/** Review Wall (v2) — admin-preview-only. Real embed markup lives in widget-v2.js (renderWall). */
const WidgetTemplate20: FC<IWidgetTemplate> = ({ company, review, style }) => {
  const companyId = company?.companyId;
  const resolvedStyle = resolveWidgetV2Style("wall", style);
  const payload = useMemo(() => ({ companyId, widgetId: 20 as const }), [companyId]);
  const profileUrl = useMemo(
    () => `https://www.trustfinance.com/companies/${companyId}?utm_source=widget&utm_medium=dom&utm_campaign=widget-v2-wall`,
    [companyId],
  );

  if (resolvedStyle === "compact-list") {
    const items = (review?.data ?? []).slice(0, 3);
    return (
      <a
        href={profileUrl}
        target="_blank"
        rel="noopener"
        onClick={() => ReachClick(payload)}
        className="d-grid"
        style={{ textDecoration: "none", color: "#1c1c2e", maxWidth: 280, margin: "0 auto", gap: 4 }}
      >
        {items.map((item, i) => (
          <div
            key={item.id}
            className="d-flex align-items-center gap-2"
            style={{ fontSize: 10.5, padding: "4px 0", borderBottom: i === items.length - 1 ? "none" : "1px solid #e7e8ec" }}
          >
            <StarRate value={item.score} size={8} />
            <span className="flex-grow-1 text-truncate">{item.title}</span>
            <span style={{ color: "#9aa0b4", flexShrink: 0 }}>{item.user?.displayName ?? "Verified user"}</span>
          </div>
        ))}
      </a>
    );
  }

  const items = (review?.data ?? []).slice(0, 4);
  return (
    <a
      href={profileUrl}
      target="_blank"
      rel="noopener"
      onClick={() => ReachClick(payload)}
      className="d-block"
      style={{ textDecoration: "none", color: "#1c1c2e", maxWidth: 320, margin: "0 auto" }}
    >
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
        {items.map((item) => (
          <div key={item.id} style={{ background: "#f7f8fa", borderRadius: 6, padding: "6px 8px" }}>
            <StarRate value={item.score} size={7} />
            <div className="mt-1" style={{ fontSize: 9.5 }}>{item.title}</div>
          </div>
        ))}
      </div>
    </a>
  );
};

export default WidgetTemplate20;
